// 这里随便找了一个安卓的UA、yeahMobi要求UA为安卓的UA、确认可以固定一个UA
export const FAKE_UA = 'Mozilla/5.0 (Linux; Android 7.1.2; AFTMM Build/NS6265; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/70.0.3538.110 Mobile Safari/537.36';

/** 后台通过配置文件下发的字段 */
export const OFFER_PROPS = ['offer_id', 'af_siteid', 'alg_inter', 'c_ad_activity', 'report_type', 'firm', 'trace_id', 's2s_tracking_link'];
